module.exports = __webpack_public_path__ + "img/icon-reg-event-setting.52aad939.png";